import { TOUR_TYPE_RENTER_REQUESTED } from 'common/tourConstants';

import { SR_API_ACTION_REQUEST_TOUR_SHOWING } from 'api/actionTypes';

import askForMobileAppReview from 'client/actions/MobileApp/askForReview';
import getToursList from './getList';

export default async function requestShowing(
  { state, apiClient },
  { requestedFrom, listingId, createNewTour, startDate, availableTimes, addToTourId },
) {
  const requestTourShowingApiPayload = {
    requestedFrom,
    listingId,
    addToTourId,
    createNewTour,
    startDate,
    availableTimes,
    type: TOUR_TYPE_RENTER_REQUESTED,
  };

  await apiClient.postWithState({
    action: SR_API_ACTION_REQUEST_TOUR_SHOWING,
    queryId: String(listingId),
    state: state,
    payload: requestTourShowingApiPayload,
    async onSuccess() {
      state.set(['showTourAddedToCartTooltip'], true);
      getToursList({ state, apiClient }, { reloadTours: true, queryId: listingId });
      askForMobileAppReview({ state });
    },
  });
}
